import React from "react";
import { Col, Radio, Row, Form, ControlLabel } from "react-bootstrap";
import { User } from "../../utils/types";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export type ResultColProps = {
  users: User[];
  currentGroup: string;
  currentQuery: string;
  enableDelete: boolean;
  disabled?: boolean;
  onSyncronize: () => void;
  onSelectEnableDelete: (enableDelete: boolean) => void;
};

function ResultCol({
  users,
  currentGroup,
  currentQuery,
  enableDelete,
  disabled = false,
  onSyncronize,
  onSelectEnableDelete,
}: ResultColProps) {
  return (
    <Col sm={12} id="sycn-area">
      <div className="rsi-title">Results</div>
      <Col
        sm={12}
        className="panel panel-default"
        style={{ marginBottom: "15px", paddingBottom: "20px" }}
      >
        <h4 id="resultFieldTitle">
          {users.length} users found in under the conditions:
        </h4>
        <Col smOffset={1}>
          <h5>group: {currentGroup}</h5>
          <h5>query: {currentQuery}</h5>
        </Col>
        <BootstrapTable
          data={users.map(user => {
            return {
              fullName: `${user.name.familyName} ${user.name.givenName}`,
              primaryEmail: user.primaryEmail,
            };
          })}
          striped
          hover
        >
          <TableHeaderColumn isKey dataField="fullName">
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="primaryEmail">
            E-mail address
          </TableHeaderColumn>
        </BootstrapTable>
      </Col>
      {currentGroup === "All" && currentQuery === "" && (
        <Col sm={12} className="App">
          <div className="rsi-title">Settings for Synchronization</div>
          <Form horizontal>
            <Row style={{ alignItems: "center", display: "flex" }}>
              <Col componentClass={ControlLabel} sm={4}>
                <label>Delete users when run synchronization</label>
              </Col>
              <Col sm={8} className="button-group">
                <Radio
                  data-testid="sync-disabled"
                  name="synchronization"
                  checked={enableDelete === false}
                  onChange={() => onSelectEnableDelete(false)}
                >
                  Disabled
                </Radio>
                <Radio
                  data-testid="sync-enable"
                  name="synchronization"
                  checked={enableDelete === true}
                  onChange={() => onSelectEnableDelete(true)}
                >
                  Enabled
                </Radio>
              </Col>
            </Row>
          </Form>
        </Col>
      )}
      <button
        className="rsi-button is-primary"
        id="syncButton"
        disabled={disabled}
        onClick={() => {
          onSyncronize();
        }}
      >
        Synchronize
      </button>
    </Col>
  );
}

export default ResultCol;
